import React, { useState } from "react";
import { Grid,Modal } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi, { CancelToken } from "api/DnerhsApi";
import { trackPromise } from 'react-promise-tracker';
import FormInput from "../../Controls/Input";
import GetAppIcon from "@material-ui/icons/GetApp";
import commonMethods from "../../utils/commonMethods";
import Header from "components/Header";
import AlertMUI from '@material-ui/lab/Alert';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Button
} from "@material-ui/core";
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from '@material-ui/icons/Clear';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers";
import { ReporteApi } from "config/ApiUrls";
import Alert from "components/Alert";
import history from "../../utils/History";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Link as RouterLink, useParams ,useLocation} from "react-router-dom";
//import DescargarCertificadoVer from "layout/DescargarCertificado/FormVerCertificado";
import pie from "../../images/pie.png";
import encabezado from "../../images/encabezado.png";
import Fab from "@material-ui/core/Fab";
import "react-toastify/dist/ReactToastify.css";

const useStyles = makeStyles((theme) => ({
  main: {
    padding: theme.spacing(16),
    paddingRight: theme.spacing(16),
    paddingTop: theme.spacing(3),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  button: {
    margin: theme.spacing(),
    paddingTop: theme.spacing(2),
  },
  alert: {
    color: "#ff0000",
  },
  modal: {
    position:'absolute',
    width: 1200,
    backgroundColor: 'white',
    borderRadius: 5,
    borderColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2,4,2),
    //padding: "30px 80px 60px",
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    focus:{
      outline: 'none'
  },outline: 'none'
  }
}));

const validationSchema = yup.object().shape({
  ci: yup.string().required("Es un campo requerido")
});

const Form = () => {
  const classes = useStyles();
  const methods = useForm({
    resolver: yupResolver(validationSchema)
  });
  const { handleSubmit, errors, formState, reset } = methods;
  const [constancias, setConstancias] = useState([]);
  const [constanciaDetalles, setConstanciaDetalles] = useState([]);

  const [alumno, setAlumno] = useState("");
  const [cedula, setCedula] = useState("");
  const [formadora, setFormadora] = useState("");
  const [sede, setSede] = useState("");
  const [nacionalidad, setNacionalidad] = useState("");
  const [hoy, setHoy] = useState("");
  const [mesActual, setMesActual] = useState("");
  const [anhoActual, setAnhoActual] = useState("");

  const [warningMessage, setWarningMessage] = useState();

  const onSubmit = async (dataForm) => {
    setWarningMessage();

    let source = CancelToken.source();
    try {
      let url = `/constancias/listado-practicas-cedula?cedula=${dataForm.ci}`;
      const { data } = await DnerhsApi(url, {
        cancelToken: source.token,
      });

      if (data && data.length > 0) {
        setConstancias(data);
        
      } else {
        setConstancias([]);
        setWarningMessage("¡No se encontraron datos para la búsqueda!")
      }

    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      } 
    }
  };

  const downloadFile = async (item) => {
    try {
      let name = "constancia"
      let url = `${ReporteApi.baseURL}?name=constancia&constanciaId=${item.id}`;
      trackPromise(commonMethods.downloadFile(url, `${name}_${new Date()}.pdf`, true));
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      } 
    }
  };

  const handleFormKeyPress = (event) => {
      if (event.key == "Enter") {
        event.preventDefault();
        handleSubmit(onSubmit)();
      }
  }

  const resetSearch = () => {
    reset();
    setConstancias([]);
  }
/*MODAL*/
const [modal, setModal]=useState(false);
const abrirConstancia =(item)=>{
  setAlumno(item.nombres +" " + item.apellidos);
        setNacionalidad(item.nacionalidad.nombre);
        setCedula(item.cedulaIdentidad);
        setFormadora(item.institucionFormadora.institucion);
        setSede(item.institucionFormadora.sede);
        setConstanciaDetalles(item.constanciaDetalleList);
        const fecha = new Date();
        setHoy(fecha.getDate());
       
        const monthNameLong = fecha.toLocaleString("es-AR", { month: "long" });

        setMesActual(monthNameLong);
        setAnhoActual(fecha.getFullYear());

        abrirCerrarModal();
        
}
const abrirCerrarModal =()=>{
  setModal(!modal);     
}
  const cerrarModal =()=>{
  setModal(!modal);     
}
 //  <Box sx={classes.box}>
const bodyModal= (
 
 <div className={classes.modal} align="center" classes={{focused: classes.outlinedInputFocused}}>
        <Header />
        <br/> <br/> <br/>
         <Grid container direction="row" justifyContent="center" alignItems="center">
            <Typography align="center" variant="h6" color="primary">
              Certificado de Prácticas
            </Typography>
            <br/>
          </Grid>
   <Grid container direction="row" justifyContent="flex-end" alignItems="center">      
                   
                   <Grid item className={classes.field}>
                     <Button
                       variant="contained"
                       color="primary"
                       onClick={()=>cerrarModal()}>OK
                     </Button>
                   </Grid>
                   
                 </Grid>
 </div>
 
)
  return (
    <>
   
        <Grid item xs={12}>
          <Typography align="left" variant="h5" color="primary">
Listar Prácticas por Estudiante          </Typography>
        </Grid>
        <div>
          <FormProvider {...methods}>
            <form
             onKeyPress={handleFormKeyPress}
            >
              <Grid
                container
                direction="row"
              >
                <Grid item xs={6} className={classes.form}>
                  <Grid item xs={12} className={classes.field}>
                    <FormInput 
                      name="ci" label="Ingrese el número de cédula"
                      errorobj={errors}
                      required
                      InputProps={{
                        endAdornment: (
                          <>
                            <InputAdornment position="end" onClick={resetSearch}>
                              <IconButton>
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                            <InputAdornment position="end" onClick={handleSubmit(onSubmit)}>
                              <IconButton>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          </>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </FormProvider>
        </div>
        <Grid container className={classes.form}>
          {warningMessage &&
            <Grid item xs={12}>
              <AlertMUI severity="warning">No se encontraron datos para la búsqueda </AlertMUI>
            </Grid>
          }
          <Grid item xs={12}>
            <Typography align="center" variant="h6" color="primary">
              Certificados de prácticas
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Estudiante</TableCell>
                  <TableCell align="left">Institucion</TableCell>
                  <TableCell align="left">Sede</TableCell>
                  <TableCell align="left">Carrera</TableCell>
                  <TableCell align="left">Curso</TableCell>

                  <TableCell align="left">Semestre</TableCell>
                  <TableCell align="left">Año</TableCell>
                  <TableCell align="left">Materia</TableCell>
                  <TableCell align="left">Total Horas</TableCell>
                  <TableCell align="left">Tutor</TableCell>

                  <TableCell align="left">Establecimiento</TableCell>

                  <TableCell align="center">Estado de Práctica</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {constancias.length > 0 ?
                  constancias.map((item, key) => (
                    <TableRow key={item.id}>
                      <TableCell align="left">{item.practicaDetalle.convenioEstudiante.estudiante.nombres + " " + item.practicaDetalle.convenioEstudiante.estudiante.apellidos}</TableCell>
                      <TableCell align="left">{item.convenioCarrera.convenio.institucionFormadora?.institucion}</TableCell>
                      <TableCell align="left">{item.convenioCarrera.convenio.institucionFormadora?.sede}</TableCell>
                      <TableCell align="left">{item.convenioCarrera.carreraPrograma.descripcion}</TableCell>
                      <TableCell align="left">{item.curso}</TableCell>
                      <TableCell align="left">{item.semestre}</TableCell>
                      <TableCell align="left">{item.practicaDetalle.anio}</TableCell>
                      <TableCell align="left">{item.materia}</TableCell>
                      <TableCell align="left">{item.practicaDetalle.totalHoras}</TableCell>
                      <TableCell align="left">{item.practicaDetalle.convenioTutor.tutor.nombres  + " " +item.practicaDetalle.convenioTutor.tutor.apellidos }</TableCell>
                      <TableCell align="left">{item.practicaDetalle.establecimiento.nombreServicio.nombre}</TableCell>
                      <TableCell align="center">                         
                      {item.id>0? "Confirmado":(item.practicaDetalle.practica.estado==="Práctica cronograma finalizada"? "Finalizado":"En Proceso")}
                      </TableCell>
                    </TableRow>
                  ))
                  :
                  <TableRow>
                    <TableCell colSpan={12}>
                      <Typography align="center" color="primary" variant="body1">No hay datos para mostrar</Typography>
                    </TableCell>
                  </TableRow>
                }
              </TableBody>

            </Table>
          </Grid>
          <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item className={classes.button}>
                <Button
                  variant="contained"
                  color="default"
                  onClick={() => history.goBack()}
                >
                  Atrás
                </Button>
              </Grid>
            </Grid>
        </Grid>
    
    </>
  );
};

export default Form;
